import React, { Fragment, useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import { Loader } from "../../components/Loader/Loader";
import { ReviewCard } from "../../components/ReviewCard/ReviewCard";
import { ReviewPopup } from "../../components/ReviewPopup/ReviewPopup";
import { AppDispatch } from "../../store";
import { fetchCategories, selectCategories } from "../../store/slices/categoriesSlice";
import {
  fetchReviewsByCategory,
  selectError,
  selectLoading,
  selectReviewsByCategory,
} from "../../store/slices/reviewsByCategorySlice";
import {
  Container,
  Section,
  TitleH1,
  TitleH2,
} from "../../styles/sharedStyles";

import {
  CardsGrid,
  TagButton,
  TagsPanel,
} from "./styles";

import type { Review } from "../../types/reviews";

export const Reviews = () => {
  const dispatch = useDispatch<AppDispatch>();

  const reviews = useSelector(selectReviewsByCategory);
  const categories = useSelector(selectCategories);
  const loading = useSelector(selectLoading);
  const error = useSelector(selectError);

  const [activeCategory, setActiveCategory] = useState<number | null>(null);
  const [selectedReview, setSelectedReview] = useState<Review | null>(null);

  useEffect(() => {
    dispatch(fetchCategories());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchReviewsByCategory(activeCategory));
  }, [dispatch, activeCategory]);

  return (
    <Section>
      <TitleH1>Отзывы</TitleH1>
      <TagsPanel>
        <TagButton
          onClick={() => setActiveCategory(null)}
          isActive={activeCategory === null}
        >
              Все
        </TagButton>
        {categories.map((cat) => (
          <TagButton
            key={cat.id}
            onClick={() => setActiveCategory(cat.id)}
            isActive={activeCategory === cat.id}
          >
            {cat.title}
          </TagButton>
        ))}
      </TagsPanel>
      {loading && <Loader />}
      {error && <div style={{ color: "red" }}>Ошибка: {error}</div>}

      {!loading && reviews.length === 0 ? (
        <Container>
          <TitleH2>Отзывов нет</TitleH2>
        </Container>
      ) : (
        <Fragment>
          <CardsGrid>
            {reviews.map((review) => {
              const category = categories.find(
                (cat) => cat.id === review.product.product_category
              );

              return (
                <ReviewCard
                  key={review.id}
                  review={review}
                  categoryTitle={category?.title || "Без категории"}
                  onClick={() => setSelectedReview(review)}
                  isReviewsPage
                />
              );
            })}
          </CardsGrid>

          {selectedReview && (
            <ReviewPopup
              visible={true}
              review={selectedReview}
              onClose={() => setSelectedReview(null)}
            />
          )}
        </Fragment>
      )}
    </Section>
  );
};
